import { render, staticRenderFns } from "./IntegrationSlackSettings.vue?vue&type=template&id=25c75dc2&scoped=true&"
import script from "./IntegrationSlackSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationSlackSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSlackSettings.vue?vue&type=style&index=0&id=25c75dc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c75dc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c75dc2')) {
      api.createRecord('25c75dc2', component.options)
    } else {
      api.reload('25c75dc2', component.options)
    }
    module.hot.accept("./IntegrationSlackSettings.vue?vue&type=template&id=25c75dc2&scoped=true&", function () {
      api.rerender('25c75dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/integration/slack/IntegrationSlackSettings.vue"
export default component.exports